import { styled } from '~/styled'

export const StepperStepBullet = styled('div', {
  base: [
    'flex',
    'relative',
    'p-2',
    'justify-center',
    'items-center',
    'size-8',
    'rounded-[50%]',
    'border-0',
    'bg-grey-200',
    'z-1',
    'flex-none'
  ],
  variants: {
    status: {
      default: ['bg-grey-200', 'text-grey-700'],
      active: ['bg-white', 'border-2', 'border-current', 'text-primary-900'],
      viewed: ['bg-white', 'border-2', 'border-grey-600', 'text-grey-1000'],
      completed: ['bg-primary-800', 'text-white'],
      reviewed: ['bg-primary-900', 'text-white'],
      success: ['bg-success', 'text-white']
    }
  }
})
